export const PHYSICAL_GIFT_CARD_IMAGES = {
  'friend-dont-let-friends': [
    {
      alt: 'Physical Gift Card Image - Friends Dont Let Friends Wear Bad Trousers',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/FriendsDontLetFriends03-min.jpg?v=1667308354',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Friends Dont Let Friends Wear Bad Trousers',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/FriendsDontLetFriends01-min.jpg?v=1667308354',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Friends Dont Let Friends Wear Bad Trousers',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_Holder_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Friends Dont Let Friends Wear Bad Trousers',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    }
  ],
  'got-this-gift-because': [
    {
      alt: 'Physical Gift Card Image - Got This Gift Because',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/IGotYouThisBeacuse03-min.jpg?v=1667308473',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Got This Gift Because',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/IGotYouThisBeacuse01-min.jpg?v=1667308473',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Got This Gift Because',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_Holder_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - Got This Gift Because',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    }
  ],
  'no-outer-box': [
    {
      alt: 'Physical Gift Card Image - No Outer Box',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_Holder_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    },
    {
      alt: 'Physical Gift Card Image - No Outer Box',
      height: 2000,
      id: 29282845327423,
      product_id: 6911599083583,
      src: 'https://cdn.shopify.com/s/files/1/0207/9406/files/Gift_Card_12-25_Ecom_Mockup.jpg?v=1764847551',
      width: 2000
    }
  ]
} as const
